(() => {
  const selector = '[data-pz-footer]';
  const ready = new WeakSet();
  function setup(root) {
    if (!root || ready.has(root)) return;
    ready.add(root);
    const countdown = root.querySelector('[data-pz-footer-countdown]');
    if (!countdown) return;
    const target = new Date(root.dataset.countdownDate).getTime();
    if (!Number.isFinite(target)) return;
    const fields = {
      days: countdown.querySelector('[data-pz-footer-time="days"]'),
      hrs: countdown.querySelector('[data-pz-footer-time="hrs"]'),
      min: countdown.querySelector('[data-pz-footer-time="min"]'),
      sec: countdown.querySelector('[data-pz-footer-time="sec"]')
    };
    const tick = () => {
      const delta = Math.max(0, target - Date.now());
      fields.days.textContent = String(Math.floor(delta / 86400000)).padStart(2, '0');
      fields.hrs.textContent = String(Math.floor((delta % 86400000) / 3600000)).padStart(2, '0');
      fields.min.textContent = String(Math.floor((delta % 3600000) / 60000)).padStart(2, '0');
      fields.sec.textContent = String(Math.floor((delta % 60000) / 1000)).padStart(2, '0');
    };
    tick();
    window.setInterval(tick, 1000);
  }
  const init = (scope = document) => {
    if (scope.matches?.(selector)) setup(scope);
    scope.querySelectorAll?.(selector).forEach(setup);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init(), { once: true }) : init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
